// Neu (SPEC 03 §7.2.2; DESIGN §3, webgis `DemoChip`-Anmutung) — das 26-px-Band unter der
// Kopfleiste. Es erscheint nur, wenn mindestens ein Hinweis gilt; die Zahlen sind die beiden
// API-Felder `pruefstand.geprueft`/`gesamt`, nie eine Differenz (T14).
import { useQuery } from "@tanstack/react-query";
import { holeHealth, holeVerfahren } from "../../api/client";
import { Icon } from "../ui";
import { TX } from "../../lib/texte";

/** Die Sätze des Bandes für ein Verfahren — leer heißt: kein Band. */
export function bandSaetze(v: { art: string; pruefstand: { geprueft: number; gesamt: number }; katalog?: { aktuell: number | null; entwurf: boolean } } | undefined, freigabe: boolean | undefined): string[] {
  if (!v) return [];
  const s: string[] = [];
  // "synthetisch" ist nur ein Etikett beim Anlegen (E17). Sind echte Daten freigegeben, darf ein
  // solches Verfahren echte Boegen tragen — dann waere "keine echten Kinderdaten" falsch.
  if (v.art === "synthetisch" && freigabe === false) s.push(TX.band.testdaten);
  if (v.art === "echt" && freigabe === false) s.push(TX.band.gesperrt);
  if (v.pruefstand.geprueft < v.pruefstand.gesamt) s.push(TX.band.geprueft(v.pruefstand.geprueft, v.pruefstand.gesamt));
  if (v.katalog && v.katalog.aktuell === null && v.katalog.entwurf) s.push(TX.band.katalog);
  return s;
}

export function useBand(V: string | null): string[] {
  const vq = useQuery({ queryKey: ["verfahren", V], queryFn: () => holeVerfahren(V!), enabled: !!V, staleTime: 60_000 });
  const hq = useQuery({ queryKey: ["health"], queryFn: holeHealth, staleTime: 60_000 });
  return V ? bandSaetze(vq.data, hq.data?.echte_daten_freigabe) : [];
}

export function Statusband({ saetze }: { saetze: string[] }) {
  if (!saetze.length) return null;
  const text = saetze.join(" · ");
  return (
    <div className="band" role="note" title={text}>
      <Icon name="warning" size={13} />
      <span>{text}</span>
    </div>
  );
}
